import "./RightBar.css";
import "../css/common.css";
import {Common} from "../../app/Common";

export function RightBar() {
	return <div id="right-bar">
	</div>
}
